// extracted by mini-css-extract-plugin
export default {"cardsContainer":"CardsContainer_cardsContainer__X3arP"};